import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrinidadAndTobago = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1821)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M6.49763 1.33246C5.42335 1.88694 4.41493 2.61374 3.51436 3.5143C2.61375 4.41491 1.88696 5.42333 1.33252 6.49762L9.04847 14.9515L17.5023 22.6674C18.5767 22.1129 19.5851 21.3862 20.4856 20.4856C21.3863 19.585 22.113 18.5766 22.6675 17.5023L14.9515 9.04841L6.49763 1.33246Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20.4856 20.4856C20.989 19.9822 21.438 19.4451 21.8332 18.8817L5.11832 2.16675C4.55493 2.56195 4.01779 3.01092 3.5144 3.51431C3.01101 4.0177 2.56204 4.55484 2.16679 5.11828L18.8817 21.8332C19.4451 21.4379 19.9822 20.989 20.4856 20.4856Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.51431 20.4856C7.30026 24.2716 12.986 24.9983 17.5023 22.6674L1.33251 6.49762C-0.998347 11.0138 -0.271457 16.6997 3.51431 20.4856Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20.4856 3.51437C16.6997 -0.271537 11.0139 -0.998288 6.49767 1.33248L22.6674 17.5024C24.9983 12.9862 24.2716 7.30028 20.4856 3.51437Z",
				fill: "#D80027"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1821",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgTrinidadAndTobago;
